export function log(argument: any, force?: boolean) {
    if (force) {
        console.log(argument);
    } else if (process.env.NODE_ENV === 'development' && process.env.logLevels === 'info') {
        console.log(argument);
    }
}
